export const PATH_PREFIX = {
  SEIMITSU: '/seimitsu/issues',
  KENSHIN: '/kenshin/issues',
  ISSUES: '/issues',
};
